import HttpService from '@pingum/api-services/HttpService';

export default class HorsePublicShareService {
  static getHorsePublicShare(id) {
    if (!id) {
      return Promise.reject(new Error('Missing Sharing ID'));
    }
    return this.httpService.get(`/${id}`);
  }

  static deleteHorsePublicShare(id) {
    if (!id) {
      return Promise.reject(new Error('Missing Sharing ID'));
    }

    return new Promise((resolve, reject) => {
      this.httpService.delete(`/${id}`).then((response) => {
        resolve(response);
      }, (error) => reject(new Error(error.data.message)));
    });
  }

  static updateHorsePublicShare(id, request) {
    if (!id) {
      return Promise.reject(new Error('Missing Sharing ID'));
    }

    return new Promise((resolve, reject) => {
      this.httpService.patch(`/${id}`, request).then((response) => {
        resolve(response);
      }, (error) => reject(new Error(error.data.message)));
    });
  }

  static getHorseFile(id, fileId, fileName) {
    return this.httpService.getFileDownload(`/${id}/files/${fileId}/${fileName}`);
  }

  static getHorseFileAvatar(id) {
    return this.httpService.getFileDownload(`/${id}/files/${id}/temp-avatar-file-name?horseAvatar=true`);
  }
}

HorsePublicShareService.httpService = new HttpService({
  baseURL: `${typeof window !== 'undefined'
    ? env.REACT_APP_HORSE_API
    : ''}/horsePublicShares`,
});
